module.exports = __webpack_public_path__ + "i18n/es.2711730ee7ba6583f1a9bb4e2a9752a2.json";